import * as React from 'react'

const SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={props.width || '44'}
    height={props.height || '44'}
    viewBox='0 0 44 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M39.1111 0H4.88889C2.2 0 0 2.2 0 4.88889V39.1111C0 41.8 2.2 44 4.88889 44H39.1111C41.8 44 44 41.8 44 39.1111V4.88889C44 2.2 41.8 0 39.1111 0ZM39.1111 39.1111H4.88889V4.88889H39.1111V39.1111Z'
      fill='#1D1D1F'
    />
    <path
      d='M20.1667 11.5378H7.94444V15.2044H20.1667V11.5378Z'
      fill='#1D1D1F'
    />
    <path
      d='M36.6667 31.1667H24.4444V34.8333H36.6667V31.1667Z'
      fill='#1D1D1F'
    />
    <path
      d='M36.6667 25.0556H24.4444V28.7222H36.6667V25.0556Z'
      fill='#1D1D1F'
    />
    <path
      d='M12.2222 36.6667H15.8889V31.7778H20.7778V28.1111H15.8889V23.2222H12.2222V28.1111H7.33333V31.7778H12.2222V36.6667Z'
      fill='#1D1D1F'
    />
    <path
      d='M27.1089 19.4333L30.5556 15.9867L34.0022 19.4333L36.5933 16.8422L33.1467 13.3711L36.5933 9.92444L34.0022 7.33333L30.5556 10.78L27.1089 7.33333L24.5178 9.92444L27.9644 13.3711L24.5178 16.8422L27.1089 19.4333Z'
      fill='#1D1D1F'
    />
  </svg>
)

export default SvgIcon
